import { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSpouses } from '../../../global/ducks/person-prc-api';
import { DemographicsContext } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { RelationshipsState } from '../features/relationships/relationships-model';
import { dispatchSetSpouses, dispatchSetSpousesFailed } from '../features/relationships/relationships-slice';

export function useSpouseInformation(personGuid: string): boolean {
    const dispatch = useDispatch();
    const app = useContext(DemographicsContext);
    const relationshipState = useSelector<TcsmStates, RelationshipsState>(state => state.relationships[app]);

    useEffect(() => {
        if (!relationshipState.spousesFetched && personGuid) {
            dispatch(getSpouses(personGuid, false, dispatchSetSpouses(dispatch, app), () => dispatchSetSpousesFailed(dispatch, app)));
        }
    }, [personGuid]);


    return (!!personGuid && relationshipState.spousesFetched && relationshipState.loadingSpousePersons === 0) || false;
}

